import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"
import { colors } from "@/styles/colors"

const useStyles = makeStyles({
	sectionLabel: {
		fontSize: "13px",
		fontWeight: 800,
		color: themeColors.colors.system.gray[800],
		marginBottom: "8px"
	},
	infoBox: {
		backgroundColor: colors.purple[50],
		border: `1px solid ${colors.purple[200]}`,
		borderRadius: "11px",
		padding: "12px 14px",
		display: "flex",
		alignItems: "flex-start",
		gap: "10px"
	},
	infoBoxIcon: {
		width: "30px",
		height: "30px",
		minWidth: "30px",
		borderRadius: "8px",
		backgroundColor: colors.purple[400],
		display: "flex",
		alignItems: "center",
		justifyContent: "center"
	},
	infoBoxText: {
		flex: 1,
		fontSize: "12.5px",
		color: themeColors.colors.system.gray[600],
		fontWeight: 400,
		lineHeight: 1.45
	},
	capacityDescription: {
		fontSize: "11.5px",
		color: themeColors.colors.system.gray[500],
		lineHeight: 1.45,
		marginBottom: "10px"
	},
	segmentedControl: {
		display: "flex",
		backgroundColor: colors.purple[100],
		borderRadius: "11px",
		padding: "4px",
		gap: "4px"
	},
	segmentedPill: {
		flex: 1,
		textAlign: "center",
		fontSize: "13.5px",
		fontWeight: 800,
		padding: "9px 0",
		borderRadius: "8px",
		cursor: "pointer",
		border: "none",
		transition: "all 0.2s ease"
	},
	segmentedPillActive: {
		backgroundColor: themeColors.colors.system.purple[600],
		color: themeColors.colors.base.white,
		boxShadow: "0 2px 6px -1px rgba(108,76,241,.4)"
	},
	segmentedPillInactive: {
		backgroundColor: "transparent",
		color: "#7a7588"
	},
	capacityLevelDescription: {
		backgroundColor: colors.purple[50],
		border: `1px solid ${colors.purple[200]}`,
		borderRadius: "10px",
		padding: "11px 13px",
		marginTop: "10px"
	},
	capacityLevelText: {
		flex: 1,
		fontSize: "11.5px",
		color: themeColors.colors.system.gray[600],
		lineHeight: 1.45
	},
	prerequisiteWarning: {
		padding: "12px 14px",
		borderRadius: "11px",
		backgroundColor: themeColors.colors.warning[50],
		border: `1px solid ${themeColors.colors.warning[100]}`,
		marginTop: "16px"
	},
	prerequisiteWarningText: {
		flex: 1,
		fontSize: "12.5px",
		color: themeColors.colors.system.gray[700],
		lineHeight: 1.45
	}
})

export default useStyles
